var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurityOff = function SvgSecurityOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.1 2.743-1.333.138v13.311c0 3.043 1.893 5.872 5.01 7.485l7.886 4.082.807.417.807-.417 7.887-4.082c3.116-1.613 5.01-4.442 5.01-7.485V2.881l-1.335-.138-12.18-1.261-.189-.02-.189.02Z",
    fill: "url(#security-off_svg__a)",
    stroke: "#fff",
    strokeWidth: 2.771,
    style: {
      fill: "url(#security-off_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.65 3.994v12.198c0 2.609-1.622 5.033-4.293 6.415L20.47 26.69V2.733Z",
    fill: "url(#security-off_svg__b)",
    style: {
      fill: "url(#security-off_svg__b)",
      strokeWidth: 1.38556
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "security-off_svg__a",
    x1: 11.814,
    y1: 4.142,
    x2: 11.814,
    y2: 23,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.52256 0 0 1.26088 2.2 -1.05)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "security-off_svg__b",
    x1: 11.814,
    y1: 4.142,
    x2: 11.814,
    y2: 23,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.52256 0 0 1.26088 2.2 -1.05)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03B03"
  })))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontSize: "9.33333px",
      lineHeight: 1.25,
      fontFamily: "sans-serif"
    },
    x: -0.205,
    y: 39.22
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.205,
    y: 39.22,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "9.33333px",
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif Bold'"
    }
  }, "SECURE")));
};
export default SvgSecurityOff;